import React from 'react'
import { compose } from 'recompose'
import DynamicLinkModalLayout from './DynamicLinkModalLayout'
import DynamicLinkView from './DynamicLinkView'
import withPortalId from '../../../modules/portal/withPortalId'
import { requestDynamicLink } from '../../../modules/portal-remote/portalService'
import { withModalBuilder } from '../../../modules/modal/withModalBuilder'

class DynamicLinkModalContainer extends React.Component {
  state = {
    data: {
      portal: {
        url: undefined,
        qrCode: undefined,
      },
      town: {
        url: undefined,
        qrCode: undefined,
      },
    },
    flashMessage: undefined,
  }

  async componentWillMount() {
    try {
      const data = await requestDynamicLink(this.props.portalId)
      this.setState({ data })
    } catch (error) {
      this.setState({ flashMessage: error.message })
    }
  }

  render() {
    const {
      data: { portal, town },
    } = this.state

    return (
      <DynamicLinkModalLayout
        flashMessage={this.state.flashMessage}
        onClose={this.props.onClose}
        title="แชร์ลิงค์"
        renderPortalLink={
          <DynamicLinkView
            title="PORTAL LINK"
            url={portal.url}
            qrCode={portal.qrCode}
          />
        }
        renderTownLink={
          <DynamicLinkView
            title="TOWN LINK"
            url={town.url}
            qrCode={town.qrCode}
          />
        }
      />
    )
  }
}

export default compose(
  withPortalId,
  withModalBuilder({ isStatic: false }),
)(DynamicLinkModalContainer)



// WEBPACK FOOTER //
// ./src/components/templates/dynamic-link/DynamicLinkModalContainer.js